export default __webpack_public_path__ + "static/media/Chris.b5ce3204.jfif";